var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-info"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.value))]),(_vm.bordered)?_c('em'):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }